module.exports = __webpack_public_path__ + "static/media/Mobilite.934102dd.webp";